import { queryOptions } from '@tanstack/react-query';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

const method = api.getCompanyCurrentbylaw;

type Response = Awaited<ReturnType<typeof method> | undefined>;

function getBylawsQuery(opts: RequestOpts = {}) {
  const queryKey = ['bylaws'];
  return queryOptions<Response>({
    queryKey,
    queryFn: ({ signal }) => {
      return method({
        ...opts,
        signal,
      });
    },
  });
}

export async function fetchBylawsQuery(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getBylawsQuery(opts));
}
